"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.workScheduleBetweenItems = exports.isPeriodOfTheDayWithoutAllday = exports.periodsOfTheDayWithoutAllday = exports.periodsOfTheDay = exports.daysOfWeek = exports.agendaRruleSchema = exports.slotRecurrenceFrequencies = void 0;
const rrule_1 = require("../agenda-slots/rrule");
exports.slotRecurrenceFrequencies = ['weekly', 'every-2-weeks'];
exports.agendaRruleSchema = rrule_1.rruleSchema.nullable();
exports.daysOfWeek = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
];
exports.periodsOfTheDay = [
    'allday',
    'morning',
    'afternoon',
    'night',
];
/**
 * Periods a single availability/leave entry or Dazz half-day classification
 * can cover — excludes the composite `allday` (= morning + afternoon).
 */
exports.periodsOfTheDayWithoutAllday = [
    'morning',
    'afternoon',
    'night',
];
/**
 * Type guard for non-allday periods (morning, afternoon, night).
 *
 * @param value - the raw period value to test
 * @returns true when the value is a valid non-allday period
 */
const isPeriodOfTheDayWithoutAllday = (value) => exports.periodsOfTheDayWithoutAllday.includes(value);
exports.isPeriodOfTheDayWithoutAllday = isPeriodOfTheDayWithoutAllday;
exports.workScheduleBetweenItems = [
    {
        id: 'none',
        label: 'period-of-day.none',
        value: null,
    },
    {
        id: 'morning',
        label: 'period-of-day.morning',
        value: {
            start: 8,
            end: 14,
        },
    },
    {
        id: 'afternoon',
        label: 'period-of-day.afternoon',
        value: {
            start: 14,
            end: 20,
        },
    },
    {
        id: 'allday',
        label: 'period-of-day.allday',
        value: {
            start: 8,
            end: 20,
        },
    },
    {
        id: 'night',
        label: 'period-of-day.night',
        value: {
            start: 20,
            end: 23,
        },
    },
];
